export type Municipio = { value: string; label: string };
export type Departamento = { value: string; label: string; municipios: Municipio[] };

export const HONDURAS_DEPARTMENTS: Departamento[] = [
  {
    value: "AT",
    label: "Atlántida",
    municipios: [
      { value: "La Ceiba", label: "La Ceiba" },
      { value: "Arizona", label: "Arizona" },
      { value: "El Porvenir", label: "El Porvenir" },
      { value: "Esparta", label: "Esparta" },
      { value: "Jutiapa", label: "Jutiapa" },
      { value: "La Masica", label: "La Masica" },
      { value: "San Francisco", label: "San Francisco" },
      { value: "Tela", label: "Tela" },
    ],
  },
  {
    value: "CH",
    label: "Choluteca",
    municipios: [
      { value: "Choluteca", label: "Choluteca" },
      { value: "Apacilagua", label: "Apacilagua" },
      { value: "Concepción de María", label: "Concepción de María" },
      { value: "Duyure", label: "Duyure" },
      { value: "El Corpus", label: "El Corpus" },
      { value: "El Triunfo", label: "El Triunfo" },
      { value: "Marcovia", label: "Marcovia" },
      { value: "Morolica", label: "Morolica" },
      { value: "Namasigüe", label: "Namasigüe" },
      { value: "Orocuina", label: "Orocuina" },
      { value: "Pespire", label: "Pespire" },
      { value: "San Antonio de Flores", label: "San Antonio de Flores" },
      { value: "San Isidro", label: "San Isidro" },
      { value: "San Marcos de Colón", label: "San Marcos de Colón" },
      { value: "Santa Ana de Yusguare", label: "Santa Ana de Yusguare" },
    ],
  },
  {
    value: "CL",
    label: "Colón",
    municipios: [
      { value: "Trujillo", label: "Trujillo" },
      { value: "Balfate", label: "Balfate" },
      { value: "Bonito Oriental", label: "Bonito Oriental" },
      { value: "El Aguacate", label: "El Aguacate" },
      { value: "Iriona", label: "Iriona" },
      { value: "Limón", label: "Limón" },
      { value: "Sabá", label: "Sabá" },
      { value: "Santa Rosa de Aguán", label: "Santa Rosa de Aguán" },
      { value: "Sonaguera", label: "Sonaguera" },
      { value: "Tocoa", label: "Tocoa" },
      { value: "Tulián", label: "Tulián" },
    ],
  },
  {
    value: "CM",
    label: "Comayagua",
    municipios: [
      { value: "Comayagua", label: "Comayagua" },
      { value: "Ajuterique", label: "Ajuterique" },
      { value: "El Rosario", label: "El Rosario" },
      { value: "Esquías", label: "Esquías" },
      { value: "Humuya", label: "Humuya" },
      { value: "La Libertad", label: "La Libertad" },
      { value: "Lamaní", label: "Lamaní" },
      { value: "La Trinidad", label: "La Trinidad" },
      { value: "Lejamaní", label: "Lejamaní" },
      { value: "Meámbar", label: "Meámbar" },
      { value: "Minas de Oro", label: "Minas de Oro" },
      { value: "Ojo de Agua", label: "Ojo de Agua" },
      { value: "San Jerónimo", label: "San Jerónimo" },
      { value: "San José de Comayagua", label: "San José de Comayagua" },
      { value: "San José del Potrero", label: "San José del Potrero" },
      { value: "San Luis", label: "San Luis" },
      { value: "San Sebastián", label: "San Sebastián" },
      { value: "Siguatepeque", label: "Siguatepeque" },
      { value: "Trinidad", label: "Trinidad" },
      { value: "Villa de San Antonio", label: "Villa de San Antonio" },
    ],
  },
  {
    value: "CP",
    label: "Copán",
    municipios: [
      { value: "Santa Rosa de Copán", label: "Santa Rosa de Copán" },
      { value: "Cabañas", label: "Cabañas" },
      { value: "Concepción", label: "Concepción" },
      { value: "Copán Ruinas", label: "Copán Ruinas" },
      { value: "Corquín", label: "Corquín" },
      { value: "Cucuyagua", label: "Cucuyagua" },
      { value: "Dolores", label: "Dolores" },
      { value: "El Paraíso", label: "El Paraíso" },
      { value: "Florida", label: "Florida" },
      { value: "La Jigua", label: "La Jigua" },
      { value: "La Unión", label: "La Unión" },
      { value: "Nueva Arcadia", label: "Nueva Arcadia" },
      { value: "San Agustín", label: "San Agustín" },
      { value: "San Antonio", label: "San Antonio" },
      { value: "San Jerónimo", label: "San Jerónimo" },
      { value: "San José", label: "San José" },
      { value: "San Juan de Opoa", label: "San Juan de Opoa" },
      { value: "San Nicolás", label: "San Nicolás" },
      { value: "San Pedro", label: "San Pedro" },
      { value: "Santa Rita", label: "Santa Rita" },
      { value: "Trinidad de Copán", label: "Trinidad de Copán" },
      { value: "Veracruz", label: "Veracruz" },
    ],
  },
  {
    value: "CR",
    label: "Cortés",
    municipios: [
      { value: "San Pedro Sula", label: "San Pedro Sula" },
      { value: "Choloma", label: "Choloma" },
      { value: "La Lima", label: "La Lima" },
      { value: "Omoa", label: "Omoa" },
      { value: "Pimienta", label: "Pimienta" },
      { value: "Potrerillos", label: "Potrerillos" },
      { value: "Puerto Cortés", label: "Puerto Cortés" },
      { value: "San Antonio de Cortés", label: "San Antonio de Cortés" },
      { value: "San Francisco de Yojoa", label: "San Francisco de Yojoa" },
      { value: "San Manuel", label: "San Manuel" },
      { value: "Santa Cruz de Yojoa", label: "Santa Cruz de Yojoa" },
      { value: "Villanueva", label: "Villanueva" },
    ],
  },
  {
    value: "EP",
    label: "El Paraíso",
    municipios: [
      { value: "Yuscaran", label: "Yuscaran" },
      { value: "Alauca", label: "Alauca" },
      { value: "Danlí", label: "Danlí" },
      { value: "El Paraíso", label: "El Paraíso" },
      { value: "Güinope", label: "Güinope" },
      { value: "Jacaleapa", label: "Jacaleapa" },
      { value: "Liure", label: "Liure" },
      { value: "Morocelí", label: "Morocelí" },
      { value: "Oropolí", label: "Oropolí" },
      { value: "Potrerillos", label: "Potrerillos" },
      { value: "San Antonio de Flores", label: "San Antonio de Flores" },
      { value: "San Lucas", label: "San Lucas" },
      { value: "San Matías", label: "San Matías" },
      { value: "Soledad", label: "Soledad" },
      { value: "Teupasenti", label: "Teupasenti" },
      { value: "Texiguat", label: "Texiguat" },
      { value: "Trojes", label: "Trojes" },
      { value: "Vado Ancho", label: "Vado Ancho" },
      { value: "Yauyupe", label: "Yauyupe" },
    ],
  },
  {
    value: "FM",
    label: "Francisco Morazán",
    municipios: [
      { value: "Tegucigalpa", label: "Tegucigalpa" },
      { value: "Alubaren", label: "Alubaren" },
      { value: "Cedros", label: "Cedros" },
      { value: "Curarén", label: "Curarén" },
      { value: "El Porvenir", label: "El Porvenir" },
      { value: "Guaimaca", label: "Guaimaca" },
      { value: "La Libertad", label: "La Libertad" },
      { value: "La Venta", label: "La Venta" },
      { value: "Lepaterique", label: "Lepaterique" },
      { value: "Maraita", label: "Maraita" },
      { value: "Marale", label: "Marale" },
      { value: "Nueva Armenia", label: "Nueva Armenia" },
      { value: "Ojojona", label: "Ojojona" },
      { value: "Orica", label: "Orica" },
      { value: "Reitoca", label: "Reitoca" },
      { value: "Sabanagrande", label: "Sabanagrande" },
      { value: "San Antonio de Oriente", label: "San Antonio de Oriente" },
      { value: "San Buenaventura", label: "San Buenaventura" },
      { value: "San Ignacio", label: "San Ignacio" },
      { value: "San Juan de Flores", label: "San Juan de Flores" },
      { value: "San Miguelito", label: "San Miguelito" },
      { value: "Santa Ana", label: "Santa Ana" },
      { value: "Santa Lucía", label: "Santa Lucía" },
      { value: "Talanga", label: "Talanga" },
      { value: "Tatumbla", label: "Tatumbla" },
      { value: "Valle de Ángeles", label: "Valle de Ángeles" },
      { value: "Vallecillo", label: "Vallecillo" },
      { value: "Villa de San Francisco", label: "Villa de San Francisco" },
    ],
  },
  {
    value: "GD",
    label: "Gracias a Dios",
    municipios: [
      { value: "Puerto Lempira", label: "Puerto Lempira" },
      { value: "Ahuas", label: "Ahuas" },
      { value: "Brus Laguna", label: "Brus Laguna" },
      { value: "Juan Francisco Bulnes", label: "Juan Francisco Bulnes" },
      { value: "Villeda Morales", label: "Villeda Morales" },
      { value: "Wampusirpi", label: "Wampusirpi" },
    ],
  },
  {
    value: "IN",
    label: "Intibucá",
    municipios: [
      { value: "La Esperanza", label: "La Esperanza" },
      { value: "Camasca", label: "Camasca" },
      { value: "Colomoncagua", label: "Colomoncagua" },
      { value: "Concepción", label: "Concepción" },
      { value: "Dolores", label: "Dolores" },
      { value: "Intibucá", label: "Intibucá" },
      { value: "Jesús de Otoro", label: "Jesús de Otoro" },
      { value: "Magdalena", label: "Magdalena" },
      { value: "Masaguara", label: "Masaguara" },
      { value: "San Antonio", label: "San Antonio" },
      { value: "San Francisco de Opalaca", label: "San Francisco de Opalaca" },
      { value: "San Isidro", label: "San Isidro" },
      { value: "San Juan", label: "San Juan" },
      { value: "San Marcos de la Sierra", label: "San Marcos de la Sierra" },
      { value: "San Miguelito", label: "San Miguelito" },
      { value: "Santa Lucía", label: "Santa Lucía" },
      { value: "Yamaranguila", label: "Yamaranguila" },
    ],
  },
  {
    value: "IB",
    label: "Islas de la Bahía",
    municipios: [
      { value: "Roatán", label: "Roatán" },
      { value: "Guanaja", label: "Guanaja" },
      { value: "José Santos Guardiola", label: "José Santos Guardiola" },
      { value: "Utila", label: "Utila" },
    ],
  },
  {
    value: "LP",
    label: "La Paz",
    municipios: [
      { value: "La Paz", label: "La Paz" },
      { value: "Aguanqueterique", label: "Aguanqueterique" },
      { value: "Cabañas", label: "Cabañas" },
      { value: "Cane", label: "Cane" },
      { value: "Chinacla", label: "Chinacla" },
      { value: "Guajiquiro", label: "Guajiquiro" },
      { value: "Lauterique", label: "Lauterique" },
      { value: "Marcala", label: "Marcala" },
      { value: "Mercedes de Oriente", label: "Mercedes de Oriente" },
      { value: "Opatoro", label: "Opatoro" },
      { value: "San Antonio del Norte", label: "San Antonio del Norte" },
      { value: "San José", label: "San José" },
      { value: "San Juan", label: "San Juan" },
      { value: "San Pedro de Tutule", label: "San Pedro de Tutule" },
      { value: "Santa Ana", label: "Santa Ana" },
      { value: "Santa Elena", label: "Santa Elena" },
      { value: "Santa María", label: "Santa María" },
      { value: "Santiago de Puringla", label: "Santiago de Puringla" },
      { value: "Yarula", label: "Yarula" },
    ],
  },
  {
    value: "LE",
    label: "Lempira",
    municipios: [
      { value: "Gracias", label: "Gracias" },
      { value: "Belén", label: "Belén" },
      { value: "Candelaria", label: "Candelaria" },
      { value: "Cololaca", label: "Cololaca" },
      { value: "Erandique", label: "Erandique" },
      { value: "Gualcince", label: "Gualcince" },
      { value: "Guarita", label: "Guarita" },
      { value: "La Campa", label: "La Campa" },
      { value: "La Iguala", label: "La Iguala" },
      { value: "Las Flores", label: "Las Flores" },
      { value: "La Unión", label: "La Unión" },
      { value: "La Virtud", label: "La Virtud" },
      { value: "Lepaera", label: "Lepaera" },
      { value: "Mapulaca", label: "Mapulaca" },
      { value: "Piraera", label: "Piraera" },
      { value: "San Andrés", label: "San Andrés" },
      { value: "San Francisco", label: "San Francisco" },
      { value: "San Juan Guarita", label: "San Juan Guarita" },
      { value: "San Manuel Colohete", label: "San Manuel Colohete" },
      { value: "San Rafael", label: "San Rafael" },
      { value: "San Sebastián", label: "San Sebastián" },
      { value: "Santa Cruz", label: "Santa Cruz" },
      { value: "Talgua", label: "Talgua" },
      { value: "Tambla", label: "Tambla" },
      { value: "Tomalá", label: "Tomalá" },
      { value: "Valladolid", label: "Valladolid" },
      { value: "Virginia", label: "Virginia" },
    ],
  },
  {
    value: "OC",
    label: "Ocotepeque",
    municipios: [
      { value: "Ocotepeque", label: "Ocotepeque" },
      { value: "Belén Gualcho", label: "Belén Gualcho" },
      { value: "Concepción", label: "Concepción" },
      { value: "Dolores Merendón", label: "Dolores Merendón" },
      { value: "Fraternidad", label: "Fraternidad" },
      { value: "La Encarnación", label: "La Encarnación" },
      { value: "La Labor", label: "La Labor" },
      { value: "Lucerna", label: "Lucerna" },
      { value: "Mercedes", label: "Mercedes" },
      { value: "San Fernando", label: "San Fernando" },
      { value: "San Francisco del Valle", label: "San Francisco del Valle" },
      { value: "San Jorge", label: "San Jorge" },
      { value: "San Marcos", label: "San Marcos" },
      { value: "Santa Fé", label: "Santa Fé" },
      { value: "Sensenti", label: "Sensenti" },
      { value: "Sinuapa", label: "Sinuapa" },
    ],
  },
  {
    value: "OL",
    label: "Olancho",
    municipios: [
      { value: "Juticalpa", label: "Juticalpa" },
      { value: "Campamento", label: "Campamento" },
      { value: "Catacamas", label: "Catacamas" },
      { value: "Concordia", label: "Concordia" },
      { value: "Dulce Nombre de Culmí", label: "Dulce Nombre de Culmí" },
      { value: "El Rosario", label: "El Rosario" },
      { value: "Esquipulas del Norte", label: "Esquipulas del Norte" },
      { value: "Gualaco", label: "Gualaco" },
      { value: "Guarizama", label: "Guarizama" },
      { value: "Guata", label: "Guata" },
      { value: "Guayape", label: "Guayape" },
      { value: "Jano", label: "Jano" },
      { value: "La Unión", label: "La Unión" },
      { value: "Mangulile", label: "Mangulile" },
      { value: "Manto", label: "Manto" },
      { value: "Salamá", label: "Salamá" },
      { value: "San Esteban", label: "San Esteban" },
      { value: "San Francisco de Becerra", label: "San Francisco de Becerra" },
      { value: "San Francisco de la Paz", label: "San Francisco de la Paz" },
      { value: "Santa María del Real", label: "Santa María del Real" },
      { value: "Silca", label: "Silca" },
      { value: "Yocón", label: "Yocón" },
    ],
  },
  {
    value: "SB",
    label: "Santa Bárbara",
    municipios: [
      { value: "Santa Bárbara", label: "Santa Bárbara" },
      { value: "Arada", label: "Arada" },
      { value: "Atima", label: "Atima" },
      { value: "Azacualpa", label: "Azacualpa" },
      { value: "Ceguaca", label: "Ceguaca" },
      { value: "Chinda", label: "Chinda" },
      { value: "Concepción del Norte", label: "Concepción del Norte" },
      { value: "Concepción del Sur", label: "Concepción del Sur" },
      { value: "El Níspero", label: "El Níspero" },
      { value: "Gualala", label: "Gualala" },
      { value: "Ilama", label: "Ilama" },
      { value: "Las Vegas", label: "Las Vegas" },
      { value: "Macuelizo", label: "Macuelizo" },
      { value: "Naranjito", label: "Naranjito" },
      { value: "Nuevo Celilac", label: "Nuevo Celilac" },
      { value: "Petoa", label: "Petoa" },
      { value: "Protección", label: "Protección" },
      { value: "Quimistán", label: "Quimistán" },
      { value: "San Francisco de Ojuera", label: "San Francisco de Ojuera" },
      { value: "San José de Colinas", label: "San José de Colinas" },
      { value: "San Luis", label: "San Luis" },
      { value: "San Marcos", label: "San Marcos" },
      { value: "San Nicolás", label: "San Nicolás" },
      { value: "San Pedro Zacapa", label: "San Pedro Zacapa" },
      { value: "Santa Rita", label: "Santa Rita" },
      { value: "Trinidad", label: "Trinidad" },
      { value: "Victoria", label: "Victoria" },
    ],
  },
  {
    value: "VA",
    label: "Valle",
    municipios: [
      { value: "Nacaome", label: "Nacaome" },
      { value: "Alianza", label: "Alianza" },
      { value: "Amapala", label: "Amapala" },
      { value: "Aramecina", label: "Aramecina" },
      { value: "Caridad", label: "Caridad" },
      { value: "Goascorán", label: "Goascorán" },
      { value: "Langue", label: "Langue" },
      { value: "San Francisco de Coray", label: "San Francisco de Coray" },
      { value: "San Lorenzo", label: "San Lorenzo" },
    ],
  },
  {
    value: "YO",
    label: "Yoro",
    municipios: [
      { value: "Yoro", label: "Yoro" },
      { value: "Arenal", label: "Arenal" },
      { value: "El Negrito", label: "El Negrito" },
      { value: "El Progreso", label: "El Progreso" },
      { value: "Jocón", label: "Jocón" },
      { value: "Morazán", label: "Morazán" },
      { value: "Olanchito", label: "Olanchito" },
      { value: "Santa Rita", label: "Santa Rita" },
      { value: "Sulaco", label: "Sulaco" },
      { value: "Victoria", label: "Victoria" },
      { value: "Yorito", label: "Yorito" },
    ],
  },
];

// Build a reverse-lookup map: municipio value -> department value
const CITY_TO_DEPT_MAP: Record<string, string> = HONDURAS_DEPARTMENTS.reduce(
  (acc, dept) => {
    dept.municipios.forEach((m) => {
      acc[m.value] = dept.value;
    });
    return acc;
  },
  {} as Record<string, string>,
);

export function getDepartmentByCity(city: string): string | undefined {
  return CITY_TO_DEPT_MAP[city];
}
